import { Timestamp, collection, doc, setDoc } from 'firebase/firestore';

import { firestore } from '../firebase';
import SupportAction, { SupportActionType, SUPPORT_ACTION_STATUSES } from '../types/SupportAction';

export const useSupportActionMutators = () => {
  const createSupportAction = async (
    personId: string,
    action: SupportActionType,
    parameters?: string[]
  ): Promise<void> => {
    const supportActionRef = doc(collection(firestore, 'supportAction'));
    const supportAction: SupportAction = {
      itemId: supportActionRef.id,
      personId,
      action,
      parameters,
      status: SUPPORT_ACTION_STATUSES.PENDING,
      createTime: Timestamp.now(),
      lastUpdateTime: Timestamp.now(),
      history: [
        {
          datetime: Timestamp.now(),
          action: 'created',
          comment: `Support action created for ${action}`,
        },
      ],
    };

    await setDoc(supportActionRef, supportAction);
  };

  return {
    createSupportAction,
  };
};
